import { KEYWORD, SIZE } from '../constants';
const buildRawQueryStringified = (checkboxSelectValues, rangeValues, entity, mustFilters = []) => {
  if (!checkboxSelectValues.length && !rangeValues.length) return '';
  const aggs = {};
  checkboxSelectValues.forEach(fieldName => {
    aggs[fieldName] = {
      terms: {
        field: `${fieldName}.${KEYWORD}`,
        size: SIZE
      }
    };
  });
  rangeValues.forEach(fieldName => {
    aggs[fieldName] = {
      stats: {
        field: fieldName
      }
    };
  });
  const boolFilter = {
    should: [{
      match: {
        docType: entity
      }
    }],
    minimum_should_match: 1
  };
  if (mustFilters.length) {
    boolFilter.must = mustFilters;
  }
  return JSON.stringify({
    aggs,
    size: 0,
    query: {
      bool: {
        filter: {
          bool: boolFilter
        }
      }
    }
  });
};
export default buildRawQueryStringified;
//# sourceMappingURL=build-raw-query-stringified.js.map